<template>
  <div class="edit-detail">
    <second-menu-link-content>
      <template v-slot:header>
        <span class="title" @click="goInformationBar">信息栏/</span>编辑详情
      </template>
      <template v-slot:content>
        <div class="edit-detail-main">
          <div class="form">
            <el-form label-position label-width="80px" :model="formData">
              <el-form-item label="标题名称：">
                <el-input v-model="formData.name" class="gray"></el-input>
              </el-form-item>
              <el-form-item label="编辑内容：">
                <div class="editor-container">
                  <editor :catchData="catchData" :content="content"></editor>
                </div>
              </el-form-item>
            </el-form>
          </div>
          <div class="btn">
            <el-button class="btn-white" @click="goInformationBar">取消</el-button>
            <el-button class="btn-blue" @click="save">保存</el-button>
          </div>
        </div>
      </template>
    </second-menu-link-content>
  </div>
</template>

<script >
import SecondMenuLinkContent from 'components/layout/SecondMenuLinkContent';
import Editor from 'base/Editor';
import DBMall from 'models/db/mall.js';
const dbMall = new DBMall();
export default {
  data() {
    return {
      content: '', // 传入富文本编辑器的值
      formData: {
        id: '',
        name: '',
        content: ''
      }
    };
  },
  components: {
    SecondMenuLinkContent,
    Editor
  },
  created() {
    let id = Number(this.$route.query.id);
    this.getDetail(id);
  },
  methods: {
    // 获取页面信息
    getDetail(id) {
      dbMall.postDBDetailBottom(id).then(res => {
        if (res.success) {
          this.formData.id = res.result.id;
          this.formData.name = res.result.title;
          this.formData.content = res.result.info;
          this.content = res.result.info;
        } else {
          this.$message.error(res.message);
        }
      });
    },
    // 返回上一层
    goInformationBar() {
      this.$router.push('information-bar');
    },
    // 富文本返回数据
    catchData(value) {
      this.formData.content = value; // 在这里接受子组件传过来的参数，赋值给data里的参数
    },
    // 保存修改
    save() {
      setTimeout(() => {
        let id = this.formData.id;
        let title = this.formData.name;
        let info = this.formData.content;
        dbMall.postDBUpdateBottomInfo(id, title, info).then(res => {
          if (res.success) {
            this.$message.success('保存成功');
            this.$router.push('/admin/mall/mall-bottom/information-bar');
          } else {
            this.$message.error(res.message);
          }
        });
      },200)
    }
  }
};
</script>

<style lang="scss" scoped>
.edit-detail {
  width: 100%;
  height: 100%;
  .title {
    color: rgba(61, 116, 242, 0.75);
    cursor: pointer;
    &:hover {
      color: rgba(61, 116, 242, 1);
    }
  }
  .btn {
    position: absolute;
    bottom: 0;
    width: 100%;
    height: 32px;
    display: flex;
    align-items: center;
    justify-content: center;
    .el-button {
      width: 96px;
      letter-spacing: 4px;
    }
    .btn-blue {
      margin-left: 24px;
    }
  }
}
</style>
<style lang="scss">
.edit-detail {
  .edit-detail-main {
    .el-form {
      .el-form-item {
        margin-bottom: 16px;
        .el-input {
          width: 360px;
        }
        .el-form-item__label {
          padding: 0;
        }
        .editor-container {
          width: 800px;
          height: 600px;
          .w-e-toolbar {
            height: 32px;
            align-items: center;
          }
          .w-e-text-container {
            height: 600px;
          }
        }
      }
    }
  }
}
</style>
